import { render, staticRenderFns } from "./ApprenticeTable.vue?vue&type=template&id=53bfd364&scoped=true&"
import script from "./ApprenticeTable.vue?vue&type=script&lang=js&"
export * from "./ApprenticeTable.vue?vue&type=script&lang=js&"
import style0 from "./ApprenticeTable.vue?vue&type=style&index=0&id=53bfd364&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bfd364",
  null
  
)

export default component.exports